export default "__VITE_ASSET__CMQpAogY__"